import React from 'react';

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function RevenueSummaryCards({ revenueStats }) {

  const cards = [
    {
      title: "Total Revenue Orders",
      value: `${numberWithCommas(revenueStats?.revenue_orders || 0)}`,
    },
    {
      title: "Total Order Earnings",
      value: `${numberWithCommas(
        revenueStats?.revenue_orders_total_earnings || 0,
      )}`,
    },
    {
      title: "Total Vendors",
      value: numberWithCommas(revenueStats?.revenue_orders_businesses || 0),
    },
    {
      title: "Total Vendor Earnings",
      value: `${numberWithCommas(
        revenueStats?.revenue_orders_businesses_earnings || 0,
      )}`,
    },
    {
      title: "Total Shippers",
      value: `${numberWithCommas(revenueStats?.revenue_orders_shippers || 0)}`,
    },
    {
      title: "Total Shipper Earnings",
      value: `${numberWithCommas(
        revenueStats?.revenue_orders_shippers_earnings || 0,
      )}`,
    },
    {
      title: "Completed Orders",
      value: numberWithCommas(revenueStats?.revenue_orders_completed || 0),
    },
    {
      title: "Failed Orders",
      value: numberWithCommas(revenueStats?.revenue_orders_failed || 0),
    },
    {
      title: "Pending Orders",
      value: numberWithCommas(revenueStats?.revenue_orders_pending || 0),
    },
    {
      title: "Queued Orders",
      value: numberWithCommas(revenueStats?.revenue_orders_queued || 0),
    },
    {
      title: "Total Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts || 0),
    },
    {
      title: "Completed Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts_completed || 0),
    },
    {
      title: "Canceled Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts_canceled || 0),
    },
    {
      title: "Pending Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts_pending || 0),
    },
    {
      title: "Queued Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts_queued || 0),
    },
    {
      title: "Failed Payouts",
      value: numberWithCommas(revenueStats?.revenue_payouts_failed || 0),
    },
    {
      title: "Completed Disbursements",
      value: `${numberWithCommas(
        revenueStats?.revenue_payouts_disbursements_completed || 0,
      )}`,
    },
    {
      title: "Pending Disbursements",
      value: `${numberWithCommas(
        revenueStats?.revenue_payouts_disbursements_pending || 0,
      )}`,
    },
    {
      title: "Queued Disbursements",
      value: numberWithCommas(
        revenueStats?.revenue_payouts_disbursements_queued || 0,
      ),
    },
    {
      title: "Failed Disbursements",
      value: numberWithCommas(
        revenueStats?.revenue_payouts_disbursements_failed || 0,
      ),
    },
  ];

  return (
    // auto-fill sizes columns from the space the page actually has (it sits
    // beside two sidebars), so cards never get squeezed: 2 on phones, more as it widens
    <div className="grid grid-cols-2 sm:grid-cols-[repeat(auto-fill,minmax(170px,1fr))] gap-3 mb-8 sm:mb-10">
      {cards.map((card) => (
        <div
          key={card.title}
          className="min-w-0 h-full flex flex-col justify-between gap-2 px-3 py-4 sm:p-5 border dark:border-none bg-white dark:bg-[#121212] rounded-md"
        >
          <h5 className="text-xs sm:text-sm leading-snug text-[#A3AED0] dark:text-[#BCBCBC]">
            {card.title}
          </h5>
          <h4 className="font-bold text-lg sm:text-2xl leading-tight break-words text-[#2B3674] dark:text-white">
            {card.value}
          </h4>
        </div>
      ))}
    </div>
  );
}
